import { getFeed } from "@/entities/feed"
import { IFeedResponse, IProductCard } from "@/shared/types/feed"
import type { WordPressObject } from "@/shared/types/wordpress"

interface GetProductsParams {
	page?: number
	limit?: number
	params?: URLSearchParams
}

const mapWordPressObjectToProductCard = (obj: WordPressObject): IProductCard => {
	return {
		id: (obj.object_id || String(obj.id)) as string,
		address: obj.address,
		description: obj.description,
		contactPhone: obj.contact_phone,
		contactMethod: obj.contact_method,
		images: Array.isArray(obj.images) ? obj.images.map(img => img.url) : [],
		category: obj.category,
		operationType: obj.operation_type,
		price: obj.price,
		rooms: obj.rooms,
		square: obj.square,
		floor: obj.floor,
		floors: obj.floors,
		houseType: obj.house_type,
		marketType: obj.market_type,
		newDevelopmentId: obj.new_development_id,
		propertyRights: obj.property_rights,
		decoration: obj.decoration,
		safeDemonstration: obj.safe_demonstration,
		status: obj.status,
		objectType: obj.object_type,
	}
}

export const getProducts = async ({
	page = 1,
	limit = 9,
	params,
}: GetProductsParams): Promise<IFeedResponse> => {
	const queryParams = new URLSearchParams(params)
	queryParams.append("page", page.toString())
	queryParams.append("limit", limit.toString())

	const response = await getFeed(queryParams.toString())
	const mappedObjects: IProductCard[] = (response.objects || []).map(
		mapWordPressObjectToProductCard
	)

	return {
		objects: mappedObjects,
		total: response.total,
		count: response.count,
		page: response.page,
		total_pages: response.total_pages,
	}
}
